import { render } from "./ArticlesBlock.vue?vue&type=template&id=7afd5a5b&scoped=true"
import script from "./ArticlesBlock.vue?vue&type=script&lang=js"
export * from "./ArticlesBlock.vue?vue&type=script&lang=js"

import "./ArticlesBlock.vue?vue&type=style&index=0&id=7afd5a5b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afd5a5b"]])

export default __exports__